import React, { useState } from 'react';
import './SpotSizePopup.css';

const SpotSizePopup = ({ onApply, handleCancel }) => {
    const [selectedSize, setSelectedSize] = useState('');
    const [applyToAll] = useState(false);

    const handleApply = () => {
        if (selectedSize) {
            onApply({ size: selectedSize, applyToAll });
            // onClose();
        }
    };

    return (
        // <div className="popup-overlay">
        <div className="spotsize-popup-container">

            {/* Title */}
            <div className="popup-title">
                <div>Parking Spot Size</div>
            </div>
            {/* Radio Options */}
            <div className="popup-row">
                <input
                    className='popup-radio-button'
                    type="radio"
                    name="spotSize"
                    value="Small"
                    checked={selectedSize === 'Small'}
                    onChange={() => setSelectedSize('Small')}
                />

                <span className="popup-text-row-small">Small (Sedan / Hatchback)</span>
            </div>

            <div className="popup-row">
                <input
                    className='popup-radio-button'
                    type="radio"
                    name="spotSize"
                    value="Medium"
                    checked={selectedSize === 'Medium'}
                    onChange={() => setSelectedSize('Medium')}
                />
                <span className="popup-text-row-small">Medium (SUV / Crossover)</span>
            </div>

            <div className="popup-row">
                <input
                    className='popup-radio-button'
                    type="radio"
                    name="spotSize"
                    value="Large"
                    checked={selectedSize === 'Large'}
                    onChange={() => setSelectedSize('Large')}
                />
                <span className="popup-text-row-small">Large (Van / Truck)</span>
            </div>

            {/* <div className="popup-row">
                <input
                    className='popup-radio-button'
                    type="radio"
                    name="spotSize"
                    value="All"
                    checked={selectedSize === 'All'}
                    onChange={() => setSelectedSize('All')}
                />
                <div className="popup-text-row-small">Apply to all parking spots</div>
            </div> */}
            {/* Apply Button */}
            <div className="popup-row-apply">
                <button
                    className={selectedSize ? 'apply-btn' : 'disabled'}
                    onClick={handleApply}
                    disabled={!selectedSize}
                >
                    APPLY
                </button>

        </div>
         </div>
    );
};

export default SpotSizePopup;
